export const SLASH_COMMANDS_STORAGE_KEY = 'finchgpt_slash_commands';
export const SLASH_COMMANDS_URL_PARAM = 'slash_commands';

export const MAX_COMMAND_NAME_LENGTH = 32;
export const MAX_COMMAND_DESCRIPTION_LENGTH = 120;
export const MAX_COMMAND_PROMPT_LENGTH = 4000;

/** Special action item ID appended to the suggestion list */
export const MANAGE_COMMANDS_ACTION_ID = '__manage_commands__';
